var map = {
	"./editorBaseApi": [
		3059
	],
	"./editorBaseApi.js": [
		3059
	],
	"./editorSimpleWorker": [
		735
	],
	"./editorSimpleWorker.js": [
		735
	],
	"./editorWorker": [
		304
	],
	"./editorWorker.js": [
		304
	],
	"./editorWorkerHost": [
		6358
	],
	"./editorWorkerHost.js": [
		6358
	],
	"./findSectionHeaders": [
		9307
	],
	"./findSectionHeaders.js": [
		9307
	],
	"./getIconClasses": [
		8148
	],
	"./getIconClasses.js": [
		8148
	],
	"./languageFeatureDebounce": [
		2060
	],
	"./languageFeatureDebounce.js": [
		2060
	],
	"./languageFeatures": [
		2230
	],
	"./languageFeatures.js": [
		2230
	],
	"./languageFeaturesService": [
		1197
	],
	"./languageFeaturesService.js": [
		1197
	],
	"./languageService": [
		3930
	],
	"./languageService.js": [
		3930
	],
	"./languagesAssociations": [
		5996
	],
	"./languagesAssociations.js": [
		5996
	],
	"./languagesRegistry": [
		6995
	],
	"./languagesRegistry.js": [
		6995
	],
	"./markerDecorations": [
		886
	],
	"./markerDecorations.js": [
		886
	],
	"./markerDecorationsService": [
		11
	],
	"./markerDecorationsService.js": [
		11
	],
	"./model": [
		4830
	],
	"./model.js": [
		4830
	],
	"./modelService": [
		931
	],
	"./modelService.js": [
		931
	],
	"./resolverService": [
		7042
	],
	"./resolverService.js": [
		7042
	],
	"./semanticTokensDto": [
		9376
	],
	"./semanticTokensDto.js": [
		9376
	],
	"./semanticTokensProviderStyling": [
		9520
	],
	"./semanticTokensProviderStyling.js": [
		9520
	],
	"./semanticTokensStyling": [
		2891
	],
	"./semanticTokensStyling.js": [
		2891
	],
	"./semanticTokensStylingService": [
		5767
	],
	"./semanticTokensStylingService.js": [
		5767
	],
	"./textModelSync/textModelSync.impl": [
		5456
	],
	"./textModelSync/textModelSync.impl.js": [
		5456
	],
	"./textModelSync/textModelSync.protocol": [
		5628,
		96
	],
	"./textModelSync/textModelSync.protocol.js": [
		5628,
		96
	],
	"./textResourceConfiguration": [
		1504
	],
	"./textResourceConfiguration.js": [
		1504
	],
	"./treeSitterParserService": [
		5320
	],
	"./treeSitterParserService.js": [
		5320
	],
	"./treeViewsDnd": [
		2603
	],
	"./treeViewsDnd.js": [
		2603
	],
	"./treeViewsDndService": [
		6756
	],
	"./treeViewsDndService.js": [
		6756
	],
	"./unicodeTextModelHighlighter": [
		9887
	],
	"./unicodeTextModelHighlighter.js": [
		9887
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi": [
		3059
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi.js": [
		3059
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker": [
		735
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker.js": [
		735
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker": [
		304
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker.js": [
		304
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost": [
		6358
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost.js": [
		6358
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders": [
		9307
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders.js": [
		9307
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses": [
		8148
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses.js": [
		8148
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce": [
		2060
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js": [
		2060
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures": [
		2230
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures.js": [
		2230
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService": [
		1197
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js": [
		1197
	],
	"monaco-editor/esm/vs/editor/common/services/languageService": [
		3930
	],
	"monaco-editor/esm/vs/editor/common/services/languageService.js": [
		3930
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations": [
		5996
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations.js": [
		5996
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry": [
		6995
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry.js": [
		6995
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations": [
		886
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations.js": [
		886
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService": [
		11
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js": [
		11
	],
	"monaco-editor/esm/vs/editor/common/services/model": [
		4830
	],
	"monaco-editor/esm/vs/editor/common/services/model.js": [
		4830
	],
	"monaco-editor/esm/vs/editor/common/services/modelService": [
		931
	],
	"monaco-editor/esm/vs/editor/common/services/modelService.js": [
		931
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService": [
		7042
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService.js": [
		7042
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto": [
		9376
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto.js": [
		9376
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling": [
		9520
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js": [
		9520
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling": [
		2891
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js": [
		2891
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService": [
		5767
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js": [
		5767
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl": [
		5456
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl.js": [
		5456
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol": [
		5628,
		96
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol.js": [
		5628,
		96
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration": [
		1504
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js": [
		1504
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService": [
		5320
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService.js": [
		5320
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd": [
		2603
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd.js": [
		2603
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService": [
		6756
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService.js": [
		6756
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter": [
		9887
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter.js": [
		9887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9204;
module.exports = webpackAsyncContext;